import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ariAppsApi } from "@/lib/api";
import type { AriAppCreate, AriAppUpdate } from "@/types";

export function useAriApps(enabled = true) {
  return useQuery({
    queryKey: ["ari-apps"],
    queryFn: () => ariAppsApi.list(),
    enabled,
  });
}

export function useAriApp(id: string) {
  return useQuery({
    queryKey: ["ari-apps", id],
    queryFn: () => ariAppsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateAriApp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AriAppCreate) => ariAppsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ari-apps"] }),
  });
}

export function useUpdateAriApp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: AriAppUpdate }) =>
      ariAppsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ari-apps"] }),
  });
}

export function useDeleteAriApp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => ariAppsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ari-apps"] }),
  });
}
